/** @format */

import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as WindowFullScreen } from "bootstrap-icons/icons/window-fullscreen.svg";
import { ReactComponent as BlendedLearningIcon } from "../../../assets/icons/resource-types/blended-learning.svg";
import { ReactComponent as KnowledgeOrganiserIcon } from "../../../assets/icons/resource-types/knowledge-organiser.svg";
import { ReactComponent as StudentPlannerIcon } from "../../../assets/icons/resource-types/student-planner.svg";
import { ReactComponent as ClassroomResourceIcon } from "../../../assets/icons/resource-types/classroom-resource.svg";
import { ReactComponent as DiagnosticToolIcon } from "../../../assets/icons/resource-types/diagnostic-tool.svg";
import { ReactComponent as QuestionBankIcon } from "../../../assets/icons/resource-types/question-bank.svg";
import { ReactComponent as OnlineExamReviewIcon } from "../../../assets/icons/resource-types/online-exam-review.svg";
import { ReactComponent as ExamWalkThroughIcon } from "../../../assets/icons/resource-types/exam-walk-through.svg";
import { ReactComponent as TeacherPlanningIcon } from "../../../assets/icons/resource-types/lesson-plan.svg";
import { ReactComponent as OtherResourcesIcon } from "../../../assets/icons/resource-types/other-resources.svg";
import "./SelectResource.scss";
import { Link } from "react-router-dom";
import HelpLink from "../../helpLink/HelpLink";

const SelectResource = () => {
  const { t: _ } = useTranslation();

  return (
    <div className="select-resource position-relative">
      <HelpLink
        position="top-end"
        className="help-link pe-0"
        locationId="new-resource"
      />
      <h3 className="mb-4">
        <WindowFullScreen /> {_("Create a resource")}
      </h3>
      <p className="mb-4">
        {_("Select the type of resource you would like to create.")}
      </p>

      <div className="resources-container">
        <div className="item">
          <Link to="/upload-bl?type=BL" className="item-link">
            <BlendedLearningIcon className="mb-2 resource-icon" />
            <p>{_("Blended Learning")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=KO" className="item-link">
            <KnowledgeOrganiserIcon className="mb-2 resource-icon" />
            <p>{_("Knowledge Organiser")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=SP" className="item-link">
            <StudentPlannerIcon className="mb-2 resource-icon" />
            <p>{_("Student Planner")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=CR" className="item-link">
            <ClassroomResourceIcon className="mb-2 resource-icon" />
            <p>{_("Classroom Resource")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=DT" className="item-link">
            <DiagnosticToolIcon className="mb-2 resource-icon" />
            <p>{_("Diagnostic Tool")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=QB" className="item-link">
            <QuestionBankIcon className="mb-2 resource-icon" />
            <p>{_("Question Bank")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=OER" className="item-link">
            <OnlineExamReviewIcon className="mb-2 resource-icon" />
            <p>{_("Online Exam Review")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=EWT" className="item-link">
            <ExamWalkThroughIcon className="mb-2 resource-icon" />
            <p>{_("Exam Walk Through")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=TP" className="item-link">
            <TeacherPlanningIcon className="mb-2 resource-icon" />
            <p>{_("TP")}</p>
          </Link>
        </div>
        <div className="item">
          <Link to="/upload?type=OR" className="item-link">
            <OtherResourcesIcon className="mb-2 resource-icon" />
            <p>{_("Other Resources")}</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SelectResource;
